exports.COOKIE = {
  KEY_TOKEN: 'access_token',
  KEY_USER: 'couser',
  MAX_AGE: 1000 * 60 * 60 * 24, // ms
  KEY_PERMISSION: 'co-permission_admin',
  KEY_TENANT: 'tenant',
  KEY_REDIRECT: 'redirect'
}
exports.ALARM_CONDITION = {
  1: '=',
  2: '>',
  3: '<',
  4: '>=',
  5: '<='
}



// WEBPACK FOOTER //
// ./src/common/const.js